/** An entity listed in a deletion dialog's usage, linked to its page when it has one (`EntityReference`). */
export type UsageReference = { id?: number; name: string; path?: string | null };

export function isUsageReferenceList(value: unknown): value is UsageReference[] {
  return Array.isArray(value) && value.length > 0 && typeof value[0]?.name === 'string';
}

// Usage groups are keyed by their DTO property name, so "bomConnections" has to
// be turned back into something readable before it is shown as a heading.
export function formatUsageCategory(key: string): string {
  const words = key.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
